exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".docs-container[data-v-367d58fa]{width:100%}", "", {"version":3,"sources":["/opt/build/repo/src/components/Docs.vue"],"names":[],"mappings":"AACA,iCACE,UAAY,CACb","file":"Docs.vue","sourcesContent":["/*-----------------------------------------------------------------------------*/\n.docs-container[data-v-367d58fa] {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-367d58fa","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./~/sass-resources-loader/lib/loader.js?{"resources":["/opt/build/repo/src/stylesheets/fonts.scss","/opt/build/repo/src/stylesheets/variables.scss","/opt/build/repo/src/stylesheets/mixins.scss"]}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Docs.vue
// module id = 1393
// module chunks = 34